export default {
	"bff92461c5b7ce465bbc65ad23ae30bd": "Make online payment",
	"4da7dfaeaef3949bdd1f8f0b6d3f2701": "Click the upper right corner of the screen",
	"2cc04bdc4e54ce88088307f6632c733c": "Select a browser to open this page"
}
